import {
  ConfigService,
  SplashConfigProtocol
} from '../../';

export class SplashConfig implements SplashConfigProtocol {
	public color		= '#FFF';
	public duration	= 0;
	public image		= '';

	constructor(private configService: ConfigService) {}

	update(config: any) {
		if (typeof config.splash === 'object') {
			this.color		= this.configService.getColor(config.splash.color, this.color);
			this.duration	= typeof config.splash.duration === 'number' ? config.splash.duration : this.duration;
			this.image		= typeof config.splash.image === 'string' ? this.configService.getImage(config.splash.image) : this.image;
		}
		
		this.configService.splash.next(this);
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/splashConfig.ts